// extracted by mini-css-extract-plugin
export default {"PricingPlans":"PricingPlan_PricingPlans__dXLfl","PriceLabel":"PricingPlan_PriceLabel__+yUCQ"};